// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as RadiobuttonUncheckedComponent} from './RadiobuttonUnchecked.svg';

import Icon, { TIconProps } from '../Icon';

export const IconRadiobuttonUnchecked = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <RadiobuttonUncheckedComponent/>
  </Icon>
));
